import type { ICustomizeTagInputValue } from '../types';

export const getTagInputValue = (payload: ICustomizeTagInputValue | null): ICustomizeTagInputValue => {
  const { tags, input } = payload || {};
  return { tags: tags || [], input: input || '' };
};

/**
 * 检测是否存在重复的tag
 * @param tags 已有tags列表
 * @param tag 即将新增的tag
 * @param options 其他参数
 * @param options.ignoreCase 是否忽略大小写
 * @param options.existedTags 已存在的标签
 * @return 是否存在重名的tag
 */
export const checkRepeatTags = (
  tags?: string[] | null,
  tag?: string,
  options?: {
    ignoreCase?: boolean;
    existedTags?: string[] | null;
  },
): boolean => {
  const { ignoreCase = false, existedTags } = options || {};
  const tagsTmp = !Array.isArray(tags) ? [] : tags;
  const existedTagsTmp = !Array.isArray(existedTags) ? [] : existedTags;
  const allTagsTmp = [...tagsTmp, ...existedTagsTmp];
  return allTagsTmp.some((item) => {
    if (!ignoreCase) return item === tag;
    return item?.toLowerCase() === tag?.toLowerCase();
  });
};
